@if (noBrandTitle && isBeNote) {
  <h3>{{noBrandTitle}}</h3>
}
@if (title) {
  <h2 class="step-title">{{title}}</h2>
}
@if (hook && isFullFastFlow) {
  <p class="step-hook">{{hook}}</p>
}
@if (subtext) {
  <h3 class="step-title">{{subtext}}</h3>
}

@if (top10FormDesign2025) {
  <div class="buttons">
    @for (button of buttonList; track button) {
      <button
        class="form-button" type="button"
        [attr.default] = "button.default ? true: null"
        (touchstart)="onlyClick ? submit(button, $event) : null"
        (click)="submit(button)"
        >
        <span class="button-icon">
          <svg aria-hidden="true">
            <use
              [attr.href]="'/assets/images/top10-icons.svg#' + button.imageName"
              [attr.xlink:href]="'/assets/images/top10-icons.svg#' + button.imageName"
            ></use>
          </svg>
        </span>
        <span class="label-text">{{button.text}}</span>
        <span class="label-info">{{button.info}}</span>
      </button>
    }
  </div>
}

@if (!top10FormDesign2025) {
  <ul>
    @for (button of buttonList; track button) {
      <li>
        <div>
          @if (onlyClick) {
            <button
              [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
              [ngStyle]="{'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
              [attr.default] = "button.default ? true: null"
              (click)="submit(button)"
              >
              <div class="button-content">
                <div class="button-image"><img src='{{ button.img || (buttonPath + "new-" + button.imageName + fileType) }}'></div>
                <div class="label">
                  <div>{{button.text}}</div>
                  <div class="label-info">{{button.info}}</div>
                </div>
              </div>
            </button>
          }
          @if (!onlyClick) {
            <button
              [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
              [ngStyle]="{'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
              [attr.default] = "button.default ? true: null"
              (click)="submit(button)"
              (touchstart)="submit(button, $event)"
              >
              <div class="button-content">
                <div class="button-image"><img src='{{ button.img || (buttonPath + "new-" + button.imageName + fileType) }}'></div>
                <div class="label">
                  <div>{{button.text}}</div>
                  <div class="label-info">{{button.info}}</div>
                </div>
              </div>
            </button>
          }
        </div>
      </li>
    }
  </ul>
}

@if (poorCreditScore) {
  <div class="poor-credit-rating-overlay">
    <div class="overlay">
      <h2 class="step-title-capitalized">{{ under500Title }}</h2>
      @if (top10FormDesign2025) {
        <div class="buttons">
          @for (button of poorCredScoreBtns; track button) {
            <button
              class="form-button" type="button"
              [attr.default] = "button.default ? true: null"
              (touchstart)="onlyClick ? validateCreditScoreOver500(button.value, $event) : null"
              (click)="validateCreditScoreOver500(button.value)"
              >
              <span class="button-icon">
                <svg aria-hidden="true">
                  <use
                    [attr.href]="'/assets/images/top10-icons.svg#' + button.imageName"
                    [attr.xlink:href]="'/assets/images/top10-icons.svg#' + button.imageName"
                  ></use>
                </svg>
              </span>
              <span class="label-text">{{button.text}}</span>
              <span class="label-info">{{button.info}}</span>
            </button>
          }
        </div>
      }
      @if (!top10FormDesign2025) {
        <ul>
          @for (button of poorCredScoreBtns; track button) {
            <li>
              @if (!onlyClick) {
                <button
                  [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
                  [ngStyle]="{'background': (button.default) ? '#e1e1e1' : '#f0ecec', 'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
                  [attr.default] = "button.default ? true: null"
                  (click)="validateCreditScoreOver500(button.value)"
                  (touchstart)="validateCreditScoreOver500(button.value, $event)"
                  >
                  <div class="button-content">
                    <div class="button-image"><img src='{{ button.img || (buttonPath + "new-" + button.imageName + fileType) }}'></div>
                    <div class="label">
                      <div>{{button.text}}</div>
                      <div class="label-info">{{button.info}}</div>
                    </div>
                  </div>
                </button>
              }
              @if (onlyClick) {
                <button
                  [ngClass]="['icon-button', 'has-shadow-small', button.className || '']"
                  [ngStyle]="{'background': (button.default) ? '#e1e1e1' : '#f0ecec', 'border' : button.borderStyle, 'box-shadow': button.boxShadow}"
                  [attr.default] = "button.default ? true: null"
                  (click)="validateCreditScoreOver500(button.value)"
                  >
                  <div class="button-content">
                    <div class="button-image"><img src='{{ button.img || (buttonPath + "new-" + button.imageName + fileType) }}'></div>
                    <div class="label">
                      <div>{{button.text}}</div>
                      <div class="label-info">{{button.info}}</div>
                    </div>
                  </div>
                </button>
              }
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
